"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAssetSymbolSVG = exports.mockSizePcbLayoutRule = exports.mockRotationPcbLayoutRule = exports.mockPositionPcbLayoutRule = exports.mockPcbLayoutRule = exports.mockPcbLayoutRuleSet = void 0;
exports.createMockPcbLayoutRuleSets = createMockPcbLayoutRuleSets;
const shared_1 = require("@buildwithflux/shared");
const structure_1 = require("../../src/pcb/node/structure");
const helpers_1 = require("../helpers");
const mockPcbLayoutRuleSet = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        selector: mockPcbRuleSetSelector(),
        rules: {
            position: (0, exports.mockPositionPcbLayoutRule)(),
            rotation: (0, exports.mockRotationPcbLayoutRule)(),
        },
        name: helpers_1.chance.animal(),
        description: helpers_1.chance.paragraph(),
        ...overrides,
    };
};
exports.mockPcbLayoutRuleSet = mockPcbLayoutRuleSet;
// randomly generates a type of Id based selector
const mockPcbRuleSetSelector = (nodes = {}) => {
    const nodesArray = Object.values(nodes);
    return (0, shared_1.getRandomArrayItem)([...Object.values(structure_1.PcbNodeTypes), ...nodesArray.map((node) => `#${node.uid}`)]);
};
const mockPcbLayoutRule = (overrides) => {
    const key = (0, shared_1.getRandomArrayItem)(["position", "rotation"]);
    return {
        uid: key,
        key: key,
        value: `${helpers_1.chance.floating({ min: -999, max: 999 })} ${helpers_1.chance.floating({ min: -999, max: 999 })} ${helpers_1.chance.floating({
            min: -999,
            max: 999,
        })}`,
        ...overrides,
    };
};
exports.mockPcbLayoutRule = mockPcbLayoutRule;
const mockPositionPcbLayoutRule = (overrides) => {
    return (0, exports.mockPcbLayoutRule)({
        uid: "position",
        key: "position",
        ...overrides,
    });
};
exports.mockPositionPcbLayoutRule = mockPositionPcbLayoutRule;
const mockRotationPcbLayoutRule = (overrides) => {
    return (0, exports.mockPcbLayoutRule)({
        uid: "rotation",
        key: "rotation",
        ...overrides,
    });
};
exports.mockRotationPcbLayoutRule = mockRotationPcbLayoutRule;
const mockSizePcbLayoutRule = (overrides) => {
    return (0, exports.mockPcbLayoutRule)({
        uid: "size",
        key: "size",
        ...overrides,
    });
};
exports.mockSizePcbLayoutRule = mockSizePcbLayoutRule;
const mockAssetSymbolSVG = (overrides) => {
    return {
        label: "mock-asset.svg",
        isDefault: true,
        name: "mock-asset.svg",
        rawName: "mock-asset.svg",
        storageName: "mock-asset" + helpers_1.chance.guid() + ".svg",
        fileType: "svg",
        uid: helpers_1.chance.guid(),
        isThumbnail: true,
        ...overrides,
    };
};
exports.mockAssetSymbolSVG = mockAssetSymbolSVG;
function createMockPcbLayoutRuleSets(amount, nodesToSelect) {
    const result = {};
    for (let i = 0; i < amount; i++) {
        const pcbLayoutRuleSet = (0, exports.mockPcbLayoutRuleSet)({
            selector: mockPcbRuleSetSelector(nodesToSelect),
        });
        result[pcbLayoutRuleSet.uid] = pcbLayoutRuleSet;
    }
    return result;
}
//# sourceMappingURL=mockPcbRuleData.js.map